import * as React from "react";
import type { SVGProps } from "react";
const SvgCalculatorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="calculator_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M128 234.667A170.667 170.667 0 0 1 298.667 64h426.666A170.667 170.667 0 0 1 896 234.667v554.666A170.667 170.667 0 0 1 725.333 960H298.667A170.667 170.667 0 0 1 128 789.333V234.667zm170.667-85.334a85.333 85.333 0 0 0-85.334 85.334v554.666a85.333 85.333 0 0 0 85.334 85.334h426.666a85.333 85.333 0 0 0 85.334-85.334V234.667a85.333 85.333 0 0 0-85.334-85.334H298.667zm0 149.334A85.333 85.333 0 0 1 384 213.333h256a85.333 85.333 0 0 1 85.333 85.334V384A85.333 85.333 0 0 1 640 469.333H384A85.333 85.333 0 0 1 298.667 384v-85.333zm341.333 0H384V384h256v-85.333zM384 597.333a42.667 42.667 0 1 1-85.333 0 42.667 42.667 0 0 1 85.333 0zm170.667 0a42.667 42.667 0 1 1-85.334 0 42.667 42.667 0 0 1 85.334 0zm128 42.667a42.667 42.667 0 1 0 0-85.333 42.667 42.667 0 0 0 0 85.333zM384 746.667a42.667 42.667 0 1 1-85.333 0 42.667 42.667 0 0 1 85.333 0zm128 42.666A42.667 42.667 0 1 0 512 704a42.667 42.667 0 0 0 0 85.333zm213.333-42.666a42.667 42.667 0 1 1-85.333 0 42.667 42.667 0 0 1 85.333 0z"
    />
  </svg>
);
export default SvgCalculatorIcon;
